// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3fumE","legacyBtn":"MutateMid_legacyBtn__2hfpA"};